import moment from "moment";
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
};
import { WizClassifySelect } from '@/containers/common'
const columns = () => {
    return [
        {
          title: '课程名称',
          name: 'searchName',
          searchItem: {}
        },
        {
            title: '课程名称',
            name: 'name',
            tableItem: {
              width: 200
            }
        },
        {
          title: '课程编码',
          name: 'searchCode',
          searchItem: {}
        },
        {
          title: "所属分类",
          name: "typeList",
          dict: [],
          searchItem: {
            type: 'diy',
            diy: WizClassifySelect,
            returnKey: true,
            wizTreeSelectListProps: {
              itemProps: {
                icon: 'unordered-list',
                title: '培训分类',
                tips: '请勾选所属培训分类'
              },
              treeProps: { checkStrictly: true }
            },
            apiProps: { type: 1 },
            selectProps: {
              placeholder: '请选择培训分类'
            }
      
          }
        },
      
        {
            title: '课程编码',
            name: 'code',
            tableItem: {
              width: 250
            }
        },
        
      {
        title: '结束时间',
        name: 'endDate',
        tableItem: {
          width: 230,
          render: text => {
            return formatterDate(text)
          }
        }
      },
        {
          title: "所属分类",
          name:'categoryNames',
          tableItem: {
            width: 250
          }
        },

    ]
};

const tableApi = (api = {}) => {
    return {
        path: 'offlineProgramManagement/getListByPage',
        ...api
    }
};

const offlineProgram = (self, api) => {
    return {
        type: 'diy',
        initialValue: [],
        columns: columns(),
        tableApi: tableApi(api)
    }
}

export default offlineProgram
